import { createFileRoute } from "@tanstack/react-router";
import { ChevronRight, Timer, TimerIcon } from "lucide-react";

export const Route = createFileRoute("/_web/_layout/blog/")({
  component: RouteComponent,
});

function RouteComponent() {
  const blogPosts = [
    {
      id: 1,

      date: "Apr 21, 2025",
      title: "Top 10 AI Essay Writers for Students and Professionals",
      excerpt:
        "Discover the most effective AI tools to enhance your writing workflow and improve productivity.",
      readTime: "8 min",
    },
    {
      id: 2,

      date: "Apr 9, 2025",
      title: "How to Calculate Your H-index Using Scopus",
      excerpt:
        "A step-by-step guide to determining your academic impact using citation metrics.",
      readTime: "6 min",
    },
    {
      id: 3,

      date: "Apr 30, 2025",
      title: "Cause and Effect Essay Examples & Writing Tips",
      excerpt:
        "Master the art of analytical writing with these proven techniques and real-world examples.",
      readTime: "10 min",
    },
    {
      id: 4,

      date: "Apr 28, 2025",
      title: "Understanding the Different Types of Literature Reviews",
      excerpt:
        "Learn the key differences between narrative, systematic, and meta-analytic literature reviews.",
      readTime: "7 min",
    },
    {
      id: 5,

      date: "Apr 25, 2025",
      title: "Cyberbullying Essay Examples and How to Use Them",
      excerpt:
        "Practical approaches to discussing digital ethics and online behavior in academic writing.",
      readTime: "9 min",
    },
  ];

  return (
    <div className="max-w-3xl mx-auto py-10 px-4 mt-14">
      <h1 className="text-5xl font-bold font-epilogue text-center mb-10">
        Blog
      </h1>

      <div className=" space-y-8 ">
        {blogPosts.map((post) => (
          <div
            key={post.id}
            className="group cursor-pointer bg-white rounded-xl shadow-sm hover:shadow-md transition-all p-6 border border-gray-100"
          >
            <div className="text-gray-400 text-sm flex gap-x-1 items-center">
              <Timer className="h-4 w-4" />
              <span className="pt-1">{post.readTime}</span>
            </div>

            <h2 className="text-md font-bold mb-2 group-hover:text-secondary-800 transition-colors">
              {post.title}
            </h2>

            <p className="text-gray-600 mb-4 line-clamp-2">{post.excerpt}</p>

            <div className="flex justify-between items-center">
              <span className="text-gray-500 text-sm">{post.date}</span>
              <span className="text-secondary-800 font-medium text-sm flex items-center group-hover:translate-x-1 transition-transform">
                Read more
                <ChevronRight />
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
